<lib-table
  [id]="id()"
  [dataSource]="dataSource()"
  [columns]="columns()"
  [parentColumns]="parentColumns()"
  [bodyTabTemplateRef]="bodyTemplates()"
  [tableClass]="tableClass()"
  [loading]="loading()"
  [viewCount]="viewCount()"
  [enableFilterRouting]="enableFilterRouting()"
  [tableFilterTabs]="tableFilterTabs()"
  [allowViewToggle]="allowViewToggle()"
  [isTableExportable]="isTableExportable()"
  [emptyStateTemplateRef]="emptyStateTemplateRef()"
  [tableActionSectionRef]="tableActionSectionRef()"
  [searchTemplateRef]="searchTemplateRef()"
  [filterDropdownTemplateRef]="filterDropdownTemplateRef()"
  [isCalendarViewEnabled]="isCalendarViewEnabled()"
  [calendarTemplateRef]="calendarTemplateRef()"
  [galleryCardTemplateRef]="galleryCardTemplateRef()"
  [galleryClass]="galleryClass()"
  [(isGalleryView)]="isGalleryView"
  [(isCalendarView)]="isCalendarView"
  [tableAction]="false"
  [titleBottomBorder]="false"
  [lastColumnAlignment]="lastColumnAlignment()"
  [rowClass]="rowClassFn()"
  [rowTestId]="rowTestIdFn()"
  [enableRowClick]="enableRowClick()"
  [isTreeTable]="true"
  (handleSortColumn)="handleSortColumn.emit($event)"
  (handleTableFilterTab)="handleTableFilterTab.emit($event)"
  (handleViewIconClick)="handleViewIconClick.emit($event)"
  (submitTableExport)="submitTableExport.emit($event)"
  (handleRowClick)="handleRowClick.emit($event)" />

<ng-template #treeCell let-row>
  <div
    class="flex items-center gap-md"
    [style.padding-inline-start.px]="row.depth * indentPx">
    @if (row.hasChildren) {
      <button
        type="button"
        class="size-6 flex items-center justify-center rounded-sm border border-neutral-200 bg-white cursor-pointer"
        [attr.aria-expanded]="row.isExpanded"
        [attr.aria-label]="
          (row.isExpanded ? collapseAriaLabel() : expandAriaLabel()) | transloco
        "
        [attr.data-testid]="toggleTestIdPrefix() + '-' + row.id"
        (click)="toggleRow($event, row)">
        <lib-chevron-down-icon
          [iconClass]="
            row.isExpanded
              ? 'size-4 text-neutral-500'
              : 'size-4 text-neutral-500 -rotate-90 rtl:rotate-90'
          " />
      </button>
    } @else {
      <span class="size-6 flex items-center justify-center">
        <span class="size-1.25 rounded-full bg-neutral-400"></span>
      </span>
    }

    <ng-container
      [ngTemplateOutlet]="labelTemplate()"
      [ngTemplateOutletContext]="{ $implicit: row }" />
  </div>
</ng-template>
